import { action, computed } from 'mobx';
import { ProductBaseController } from '../../../src/internal/controllers/ProductBaseController';
import { IProductDetails } from '../interfaces/IProductFullOrderable';
import { buildIngredientsContent } from '../utils/ContentFormatter';
import { IComparisonItemWrapper } from '../views/product-comparison/ComparisonItemWrapper';

export class ComparisonItemViewController extends ProductBaseController {
    @action
    public initialize(props: IComparisonItemWrapper) {
        this.setProduct(props.product);
        this.positionIndex = props.positionIndex;
    }

    @computed
    public get data() {
        return {
            product: this.product,
            selectedSku: this.selectedSku,
            productUrl: this.selectedProductUrl,
            displayName: this.product.displayNameDecoded,
            productBadge: this.product.productBadge,
            skuBadge: this.selectedSku.skuBadge,
            largeMedia: this.largeMedia,
            alternateImage: this.selectedSku.defaultAlternateMediumImage.src,
            isUpdatedInventorySource: this.selectedSku.isUpdatedInventorySource,
            selectedAutoReplenishOption: this.selectedAutoReplenishOption,
            isAutoReplenishSelected: this.isAutoReplenishSelected,
            ...this.productDetails
        };
    }

    @computed
    public get productDetails(): IProductDetails {
        const {
            whoItsFor: { content: whoItsFor },
            greatToKnow: { content: greatToKnow },
            whatItIs: { content: whatItIs },
            whatItDoes: { content: whatItDoes },
            keyIngredient,
            howDoesItWork: { content: howDoesItWork },
            howToUse: { content: howToUse }
        } = this.product;
        const allIngredients = buildIngredientsContent(this.selectedSku);

        return {
            whoItsFor,
            greatToKnow,
            whatItIs,
            whatItDoes,
            keyIngredient,
            allIngredients,
            howDoesItWork,
            howToUse
        };
    }
}
